// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s4lx","badges":"styles_badges__2JmNj"};